import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { referralRock } from '../types/urlQueryMapping'
import { routes } from '@linqpal/models'

const {
  referralCode: { cookieName: referralCookie },
  medium: { cookieName: mediumCookie },
} = referralRock
// get referralCookie and mediumCookie cookie names

/**
 * Set ref as null for Supplier as the conversion script has to be run after the signup flow. (It won't load and run,
 * because it redirects right when the phone number is entered.
 *
 * @returns {function(): void}
 */
export const useReferralRockConversion = () => {
  const [cookies, _, deleteCookie] = useCookies([
    'user-type',
    referralCookie,
    mediumCookie,
  ])
  //setCookie is ignored, rerender is triggered when user-type, referralCookie, or mediumCookie is changed

  const referralCode = cookies[referralCookie]
  //get referralcode from referralCookie

  const referralMode = cookies[mediumCookie]
  //get referralMode from mediumCookie
  // Remove ReferralRock integration https://linqpal.atlassian.net/browse/LP-4289
  // useEffect(() => {
  //   if (referralCode) {
  //     routes.referral.addReferral(referralCode, referralMode).then(r => {
  //       [referralCookie, mediumCookie].forEach(cookie => {
  //         deleteCookie(cookie)
  //       })
  //     })
  //   }
  // }, [referralCode])
  //if referralCode changes then addReferral? and delete referralRcok cookies
}
